import { createApp } from 'vue'
import { createPinia } from "pinia";
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import Toast from "vue-toastification";
import BootstrapVue3 from "bootstrap-vue-3";
import "vue-toastification/dist/index.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import ElementPlus from "element-plus";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import ApiService from './core/services/ApiService';
import { vue3Debounce } from 'vue-debounce'
import { install } from "vue3-recaptcha-v2";
import 'leaflet/dist/leaflet.css';
import HighchartsVue from 'highcharts-vue'

const app = createApp(App);


app.use(createPinia());
app.use(router);
app.use(BootstrapVue3);
app.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
});
app.directive('debounce', vue3Debounce({ lock: true }))
app.use(ElementPlus);
app.use(HighchartsVue);
app.use(install, {
    sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    cnDomains: false,
});
ApiService.init(app);
initVeeValidate();


app.mount('#app');
